export default __webpack_public_path__ + "static/media/is_tested.161753d8.svg";